import request from '@/utils/request'
const time = new Date().getTime();
const requestPrefix = process.env.VUE_APP_ABI_URL
export function getContractTAT() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'TAT',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}

export function getContractUnitPrice() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'Expense',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}
export function getContractBid() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'Bid',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}
export function getContractUSTN() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'USTN',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}
export function getContractUSTNFinance() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'USTNFinance',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}
export function getContractGovernance() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'Governance',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}
export function getContractTCashAuction() {
  return request({
    url: `/contracts/abi?name=TCashAuction`,
    method: 'get',
  })
  // return request({
  //   url: `/splatform/api/contracts/abi`,
  //   method: 'get',
  //   params:{
  //     name:'TCashAuction',
  //     time:time
  //   },
  //   vconfig:{
  //     noBaseApi:true,
  //     noErr:true
  //   },
  //   responseType: "application/json"

  // })
}
export function getContractDao() {
  return request({
    url: `${requestPrefix}/api/contracts/abi`,
    method: 'get',
    params:{
      name:'DAO',
      time:time
    },
    vconfig:{
      noBaseApi:true,
      noErr:true
    },
    responseType: "application/json"

  })
}

export function getAbi(name) {
  return request({
    url: `/contracts/abi?name=${name}`,
    method: 'get',
  })
}

export function getNowTime(name) {
  return request({
    url: `/contracts/abi?name=Bid`,
    method: 'get',
    vconfig:{
      noErr:true
    },
  })
}


